<section class="relative flex flex-col items-center gap-6">
  <div
    class="absolute h-full w-full bg-[radial-gradient(#d1d5db_1px,transparent_1px)] [background-size:16px_16px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#000_85%,transparent_100%)]"
  ></div>
  <div class="z-10">
    <tui-badge appearance="neutral" iconStart="@tui.building" size="xl">
      Enterprise-Grade
    </tui-badge>
  </div>
  <div class="z-10 flex flex-col items-center gap-14">
    <h1 class="text-center text-4xl font-bold leading-relaxed md:text-5xl">
      @defer {
        Build, update, and publish your Capacitor apps<br /><span
          [roughNotation]="{
            animate: true,
            animationDelay: 500,
            strokeWidth: 3,
            iterations: 4,
            type: 'underline',
            color: 'var(--tui-background-accent-2)',
            padding: 2,
          }"
          >at scale</span
        >
      } @placeholder {
        Build, update, and publish your Capacitor apps<br />at scale
      }
    </h1>
    <p class="w-full text-balance text-center text-xl leading-snug md:w-3/4">
      <span class="hidden md:block"
        >The complete platform for enterprise teams. Deploy Live Updates, build
        native apps in the cloud, and automate app store publishing with
        enterprise-grade security, scalability, and support</span
      >
      <span class="md:hidden"
        >The complete Capacitor platform with enterprise-grade security,
        scalability, and support</span
      >
    </p>
    <div class="flex space-x-4">
      <a
        iconEnd="@tui.arrow-right"
        size="l"
        tuiButton
        type="button"
        [href]="bookingUrl"
        target="_blank"
        data-umami-event="enterprise-hero-request-demo-button"
      >
        Book a demo
      </a>
      <button
        appearance="secondary"
        size="l"
        tuiButton
        type="button"
        (click)="handleContactSales()"
        data-umami-event="enterprise-hero-contact-sales-button"
      >
        Contact sales
      </button>
    </div>
  </div>
</section>
